import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['info', 'checkbox'];

  connect() {
    this.toggleInfo(); // Initialize visibility on page load
  }

  toggleInfo() {
    const isChecked = this.checkboxTarget.checked;
    this.infoTarget.style.display = isChecked ? 'block' : 'none';
  }
}
